import { useState } from "react";
import { Button, ButtonGroup, Col, Form, Row } from "react-bootstrap";
import { MetricsDateSelector } from "../filters/MetricsDateSelector";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

/**
 * EvaluationReportFilterBar options
 */
export const AfibFilterBar = (props: {
    filterOptions: any;
    updateFilterOptions: any;
    filterDateOptions: any;
    setFilterDateOptions: any;
    refresh: any;
    isLoadingMetrics: boolean;
}) => {
    const [noAFChecked, setNoAFChecked] = useState(false);
    const [noACChecked, setNoACChecked] = useState(false);

    const handleCheckFilter = (checked: boolean, value: number) => {
        if (value === 0) {
            setNoAFChecked((prev) => {
                const updatedNoAF = checked;
                updateFilterArray(updatedNoAF, noACChecked);
                return updatedNoAF;
            });
        }

        if (value === 1) {
            setNoACChecked((prev) => {
                const updatedNoAC = checked;
                updateFilterArray(noAFChecked, updatedNoAC);
                return updatedNoAC;
            });
        }
    };

    const updateFilterArray = (updatedNoAF: boolean, updatedNoAC: boolean) => {
        console.log(updatedNoAF, updatedNoAC);
        let newArray: number[] = [];

        if (updatedNoAF && updatedNoAC) {
            newArray = [0, 1];
        } else if (updatedNoAF) {
            newArray = [0, 1, 5];
        } else if (updatedNoAC) {
            newArray = [0, 1, 3];
        }
        props.updateFilterOptions("prev_criteria", newArray);
    };

    const handleChaFilter = (checked: boolean, value: number) => {
        props.updateFilterOptions(
            value === 0 ? "potential_ac_candidate" : "strong_ac_candidate",
            checked
        );
    };

    return (
        <>
            <Row className="trackboard-sidebar-update">
                <Col md={12} className="d-grid gap-2">
                    <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => {
                            props.refresh();
                        }}
                        disabled={props.isLoadingMetrics}
                    >
                        {props.isLoadingMetrics ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin />{" "}
                                Loading...
                            </>
                        ) : (
                            "Update"
                        )}
                    </Button>
                </Col>
            </Row>
            <Row className="mb-4" style={{ marginTop: "48px" }}>
                <Col md={12}>
                    <div className="trackboard-control-title">Date Range</div>
                    <MetricsDateSelector
                        filterDateOptions={props.filterDateOptions}
                        setFilterDateOptions={props.setFilterDateOptions}
                    />
                </Col>
            </Row>
            <Row className="mt-2 mb-4">
                <Col md={12}>
                    <div className="trackboard-afib-control-title">
                        Previous Diagnosis
                    </div>

                    <div className="d-flex">
                        <Form.Check
                            type={"checkbox"}
                            checked={true}
                            onChange={(e) =>
                                handleCheckFilter(e.target.checked, 0)
                            }
                        >
                            <Form.Check.Input
                                id={"noAF"}
                                type="checkbox"
                                checked={noAFChecked}
                                onChange={(e) =>
                                    handleCheckFilter(e.target.checked, 0)
                                }
                            />
                            <Form.Check.Label htmlFor={"noAF"}>
                                No AF Diagnosis
                            </Form.Check.Label>
                        </Form.Check>
                    </div>

                    <div className="d-flex">
                        <Form.Check
                            type={"checkbox"}
                            checked={true}
                            onChange={(e) =>
                                handleCheckFilter(e.target.checked, 1)
                            }
                        >
                            <Form.Check.Input
                                id={"noAC"}
                                type="checkbox"
                                checked={noACChecked}
                                onChange={(e) =>
                                    handleCheckFilter(e.target.checked, 1)
                                }
                            />
                            <Form.Check.Label htmlFor={"noAC"}>
                                No Anticoagulation
                            </Form.Check.Label>
                        </Form.Check>
                    </div>
                </Col>
            </Row>
            <Row className="mt-2 mb-4">
                <Col md={12}>
                    <div className="trackboard-afib-control-title">
                        CHA2DS2–VASc
                    </div>

                    <div className="d-flex">
                        <Form.Check
                            type={"checkbox"}
                            checked={true}
                            onChange={(e) =>
                                handleChaFilter(e.target.checked, 0)
                            }
                        >
                            <Form.Check.Input
                                id={"potentialCandidate"}
                                type="checkbox"
                                checked={
                                    props.filterOptions[
                                        "potential_ac_candidate"
                                    ]
                                }
                                onChange={(e) =>
                                    handleChaFilter(e.target.checked, 0)
                                }
                            />
                            <Form.Check.Label htmlFor={"potentialCandidate"}>
                                Potential AC Candidate
                            </Form.Check.Label>
                        </Form.Check>
                    </div>
                    <div className="d-flex">
                        <Form.Check
                            type={"checkbox"}
                            checked={true}
                            onChange={(e) =>
                                handleChaFilter(e.target.checked, 1)
                            }
                        >
                            <Form.Check.Input
                                id={"strongCandidate"}
                                type="checkbox"
                                checked={
                                    props.filterOptions["strong_ac_candidate"]
                                }
                                onChange={(e) =>
                                    handleChaFilter(e.target.checked, 1)
                                }
                            />
                            <Form.Check.Label htmlFor={"strongCandidate"}>
                                Strong AC Candidate
                            </Form.Check.Label>
                        </Form.Check>
                    </div>
                </Col>
            </Row>
        </>
    );
};
